import { escapeHtml } from './html.js?v=6.87.12';

function formatDuration(seconds) {
  const total = Math.max(0, Math.floor(Number(seconds || 0)));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  const two = value => String(value).padStart(2, '0');
  return hours > 0 ? `${hours}:${two(minutes)}:${two(secs)}` : `${minutes}:${two(secs)}`;
}

function formatLocalTime(unixSeconds) {
  const value = Number(unixSeconds || 0);
  if (!Number.isFinite(value) || value <= 0) return '--:--';
  try {
    return new Intl.DateTimeFormat('ru-RU', { timeZone: 'Asia/Vladivostok', hour: '2-digit', minute: '2-digit' }).format(new Date(value * 1000));
  } catch (_) {
    return '--:--';
  }
}

export class MaintenanceBanner {
  constructor({ api, onError = () => {}, isDeveloper = () => false, isAuthenticated = () => false } = {}) {
    this.api = api;
    this.onError = onError;
    this.isDeveloper = isDeveloper;
    this.isAuthenticated = isAuthenticated;
    this.root = null;
    this.status = null;
    this.receivedAtMs = 0;
    this.pollTimer = null;
    this.tickTimer = null;
    this.refreshing = false;
    this.boundRefresh = () => { void this.refresh(); };
  }

  mount(root) {
    this.root = root;
    if (this.root) this.root.innerHTML = '';
  }

  start() {
    if (!this.root || !this.api) return;
    this.stopTimers();
    globalThis.addEventListener?.('shipsops:maintenance-refresh', this.boundRefresh);
    this.pollTimer = globalThis.setInterval(() => { void this.refresh(); }, 15000);
    this.tickTimer = globalThis.setInterval(() => this.render(), 1000);
    void this.refresh();
  }

  stop() {
    globalThis.removeEventListener?.('shipsops:maintenance-refresh', this.boundRefresh);
    this.stopTimers();
    this.status = null;
    if (this.root) this.root.innerHTML = '';
  }

  destroy() {
    this.stop();
    this.root = null;
  }

  stopTimers() {
    if (this.pollTimer !== null) globalThis.clearInterval(this.pollTimer);
    if (this.tickTimer !== null) globalThis.clearInterval(this.tickTimer);
    this.pollTimer = null;
    this.tickTimer = null;
  }

  setStatus(status) {
    this.status = status || null;
    this.receivedAtMs = Date.now();
    this.render();
  }

  async refresh() {
    if (this.refreshing || !this.api) return;
    this.refreshing = true;
    try {
      const response = await this.api.call('maintenance.status.get', {}, { dedupeKey: 'maintenance.status' });
      this.status = response?.maintenance || null;
      this.receivedAtMs = Date.now();
      this.render();
    } catch (error) {
      if (error?.code !== 'authentication_required') console.warn('Maintenance status refresh failed', error);
    } finally {
      this.refreshing = false;
    }
  }

  serverNowUnix() {
    const base = Number(this.status?.server_now_unix || 0);
    if (!base || !this.receivedAtMs) return Math.floor(Date.now() / 1000);
    return base + Math.floor(Math.max(0, Date.now() - this.receivedAtMs) / 1000);
  }

  expireLocally(status) {
    this.status = {
      ...(status || {}),
      enabled: false,
      phase: 'none',
      seconds_to_start: 0,
      seconds_to_end: 0,
    };
    if (this.root) this.root.innerHTML = '';
  }

  render() {
    if (!this.root) return;
    const status = this.status;
    const now = this.serverNowUnix();
    if (!status?.enabled) {
      this.root.innerHTML = '';
      return;
    }
    if (Number(status.ends_at_unix || 0) <= now) {
      this.expireLocally(status);
      void this.refresh();
      return;
    }

    const startsAt = Number(status.starts_at_unix || 0);
    const endsAt = Number(status.ends_at_unix || 0);
    if (startsAt > now) {
      this.root.innerHTML = `<aside class="rc5-maintenance-countdown" role="status" aria-live="polite"><span>До техработ:</span><strong>${escapeHtml(formatDuration(startsAt - now))}</strong></aside>`;
      return;
    }

    if (this.isDeveloper() || !this.isAuthenticated()) {
      this.root.innerHTML = '';
      return;
    }

    this.root.innerHTML = `<div class="rc5-maintenance-overlay" role="alertdialog" aria-modal="true" aria-labelledby="rc5-maintenance-title">
      <section class="rc5-maintenance-card">
        <h2 id="rc5-maintenance-title">Ведутся техработы до ${escapeHtml(formatLocalTime(endsAt))}</h2>
        <p>Доступ к рабочим разделам временно закрыт. Окно исчезнет автоматически после окончания техработ.</p>
        <div class="rc5-maintenance-frog" aria-hidden="true"><video src="assets/maintenance/captain-vrungel-loading-alpha.webm?v=1" autoplay loop muted playsinline></video></div>
      </section>
    </div>`;
  }
}
